var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      class: { "ia-w-mark--animated": _vm.animated },
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 520 370",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", { attrs: { d: _vm.bodyD, fill: _vm.color } }),
      _c("path", { attrs: { d: _vm.legD, fill: _vm.color } }),
      _vm.animated
        ? [
            _c(
              "defs",
              [
                _c("clipPath", { attrs: { id: _vm.clipId } }, [
                  _c("path", { attrs: { d: _vm.bodyD } }),
                  _c("path", { attrs: { d: _vm.legD } })
                ]),
                _c(
                  "linearGradient",
                  {
                    attrs: {
                      id: _vm.gradientId,
                      x1: "0",
                      y1: "0",
                      x2: "1",
                      y2: "0.15"
                    }
                  },
                  [
                    _c("stop", {
                      attrs: {
                        offset: "0%",
                        "stop-color": "#FFFFFF",
                        "stop-opacity": "0"
                      }
                    }),
                    _c("stop", {
                      attrs: {
                        offset: "50%",
                        "stop-color": "#FFFFFF",
                        "stop-opacity": "0.95"
                      }
                    }),
                    _c("stop", {
                      attrs: {
                        offset: "100%",
                        "stop-color": "#FFFFFF",
                        "stop-opacity": "0"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c("g", { attrs: { "clip-path": "url(#" + _vm.clipId + ")" } }, [
              _c("rect", {
                staticClass: "ia-w-mark-sweep",
                attrs: {
                  x: "-160",
                  y: "-40",
                  width: "220",
                  height: "460",
                  fill: "url(#" + _vm.gradientId + ")"
                }
              })
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }